import axiosInstance from '../api/axiosInstance';

const ENDPOINTS = {
    getPosIndustries: 'techsavanna_pos.api.industry_api.get_pos_industries',
    getUserIndustry: 'techsavanna_pos.api.industry_api.get_user_industry',
    setUserIndustry: 'techsavanna_pos.api.industry_api.set_user_industry',
};

const industryService = {
    /**
     * Fetch all POS industries
     * @param {Object} params - Query parameters
     * @param {boolean} params.is_active - Filter by active status (default: true)
     * @returns {Promise<Array>} List of industries
     */
    getPosIndustries: async (params = { is_active: true }) => {
        try {
            const response = await axiosInstance.get(ENDPOINTS.getPosIndustries, { params });
            return response.data?.message?.industries || [];
        } catch (error) {
            console.error('Error fetching POS industries:', error);
            throw error;
        }
    },

    /**
     * Get the current user's industry
     * @returns {Promise<Object|null>} The user's industry or null if not set
     */
    getUserIndustry: async () => {
        try {
            const response = await axiosInstance.get(ENDPOINTS.getUserIndustry);
            return response.data?.message || null;
        } catch (error) {
            console.error('Error fetching user industry:', error);
            throw error;
        }
    },

    /**
     * Set the user's industries
     * @param {Array<string>} industryCodes - List of industry codes to set
     * @returns {Promise<Object>} The updated status
     */
    setUserIndustry: async (industryCodes) => {
        try {
            const response = await axiosInstance.post(ENDPOINTS.setUserIndustry, {
                industry_codes: industryCodes,
            });
            return response.data?.message || null;
        } catch (error) {
            console.error('Error setting user industry:', error);
            throw error;
        }
    },
};

export default industryService;
